// AUTO-GENERATED from /app/docs/legal/02_POLITICA_DE_PRIVACIDADE.md. Do not edit by hand.
export default `# Política de Privacidade — BlueGov

**Versão 1.0 · Adequada à Lei 13.709/2018 (LGPD)**

## 1. Apresentação
Esta Política descreve como o **BlueGov** (Operador) e o **Órgão Contratante** (Controlador) tratam dados pessoais durante o uso da plataforma BlueGov — Plataforma de Conformidade e Proteção Institucional.

## 2. Dados Coletados

### 2.1 Dados Cadastrais
- Nome completo, e-mail institucional, departamento, perfil (\`role\`), tenant (órgão), foto (opcional via SSO).

### 2.2 Dados de Autenticação
- Senha local com hash bcrypt **OU** identificadores Azure AD: \`external_subject\` (oid), \`external_groups\` (object IDs dos grupos), \`last_external_sync\`.

### 2.3 Logs e Trilhas de Auditoria
- \`audit_logs\` contendo: \`user_id\`, \`user_email\`, \`action\`, \`entity_type\`, \`entity_id\`, estado anterior e novo, IP, timestamp, \`previous_hash\`, \`current_hash\`, \`chain_index\`. Encadeamento SHA-256 garante imutabilidade.

### 2.4 Evidências Anexadas
- Arquivos enviados pelo usuário (PDF, imagens, documentos oficiais), com \`file_hash\` SHA-256. Armazenados em filesystem local do container, sem CDN público.

### 2.5 Dados Gerados pelos Usuários
- Atos de controle, planos de ação, respostas oficiais, dossiês executivos, pareceres, notas internas.

### 2.6 Dados Processados por IA
- A descrição textual do ato é enviada à **Emergent LLM Key** (intermediário contratado pela BlueGov) para classificação, parecer de risco e geração do resumo executivo do Dossiê. **Não são enviados** CPF, documentos confidenciais ou evidências.

## 3. Finalidade do Tratamento
- Permitir a gestão e demonstração do cumprimento de Atos de Controle.
- Calcular o IPI (Índice de Proteção Institucional).
- Gerar Dossiês Executivos verificáveis publicamente (com QR Code e hash SHA-256).
- Apurar Inteligência de Risco por ato.
- Permitir auditoria externa somente-leitura via convite com PIN.
- Notificar usuários sobre prazos, atribuições e eventos.

## 4. Base Legal
- **Execução de obrigação legal** (art. 7º, II, LGPD) — atender controle externo e interno.
- **Execução de contrato** entre BlueGov e Órgão Contratante (art. 7º, V).
- **Exercício regular de direitos** (art. 7º, VI) — defesa institucional do gestor.
- **Interesse legítimo** (art. 7º, IX) — segurança e integridade da auditoria.

## 5. Compartilhamento de Dados
Os dados são compartilhados exclusivamente com:
- **MongoDB Atlas** (banco): armazenamento técnico.
- **Railway**: hospedagem e logs operacionais.
- **Emergent LLM Key**: descrição textual do ato para IA.
- **SendGrid** (quando configurado): nome e e-mail para envio de notificação.
- **Microsoft Entra ID** (quando o tenant adota SSO): troca de tokens OIDC.
- **Auditores Externos autorizados** via convite com PIN (somente-leitura).
- **Verificação Pública** de Dossiês: a página pública \`/verify-dossier/{id}\` expõe apenas o ID do dossiê, score, hash, data e tenant — sem dados pessoais sensíveis.
- **Órgãos de Controle** (TCE, CGU, MP) quando solicitados nos termos da lei.

**Não há venda de dados a terceiros. Não há tratamento para fins de marketing.**

## 6. Retenção
- Dados de usuários ativos: enquanto durar o contrato.
- Audit logs: **mantidos integralmente** durante o contrato e por **5 anos** após o encerramento, conforme exigência de controle externo.
- Evidências e atos: enquanto durar o contrato + período exigido pela legislação de arquivos públicos.
- Após esses prazos, dados podem ser anonimizados ou excluídos definitivamente conforme instrução do Controlador.

## 7. Segurança
- Senhas armazenadas com **bcrypt**.
- Comunicação por **HTTPS** (TLS 1.2+).
- JWTs com expiração curta + state JWT assinado nos fluxos OAuth.
- Audit logs com encadeamento criptográfico SHA-256 (Hash Chain).
- Verificação pública de Dossiês via hash SHA-256 do PDF.
- Isolamento multi-tenant por \`tenant_id\` em todas as queries.
- Configurações Azure AD por tenant armazenadas em coleção dedicada (\`idp_configs\`); o client secret nunca é retornado em respostas de API.
- Validação de redirect_path com whitelist (prevenção de open-redirect).

## 8. Direitos do Titular
Nos termos do art. 18 da LGPD, o titular pode requisitar:
- **Confirmação** da existência de tratamento;
- **Acesso** aos seus dados;
- **Correção** de dados incompletos, inexatos ou desatualizados;
- **Anonimização, bloqueio ou eliminação** de dados desnecessários, excessivos ou tratados em desconformidade;
- **Portabilidade** a outro fornecedor;
- **Eliminação** dos dados tratados com consentimento;
- **Informação** sobre compartilhamentos;
- **Revogação do consentimento**.

Requisições devem ser direcionadas ao Encarregado de Dados (DPO) do Órgão Contratante. O BlueGov auxilia tecnicamente o atendimento.

## 9. Encarregado (DPO) BlueGov
**Contato:** dpo@bluegov.com.br

## 10. Atualizações desta Política
Esta Política pode ser atualizada periodicamente. Versão e data são exibidas no topo. Alterações materiais serão comunicadas ao Órgão Contratante.

---
**Versão 1.0 · Fevereiro/2026**
`;
